import React from 'react';
import { Button } from '@lumx/react';
import MdiIcon from '@mdi/react';

interface EmptyStateAction {
  label: string;
  onClick: () => void;
}

interface Props {
  icon: string;
  title: string;
  body?: string;
  action?: EmptyStateAction;
}

const EmptyState: React.FC<Props> = ({ icon, title, body, action }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    gap: 12,
    padding: '40px 24px',
  }}>
    {/* Icon circle */}
    <div style={{
      width: 56,
      height: 56,
      borderRadius: '50%',
      background: 'rgba(0,0,0,0.06)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}>
      <MdiIcon path={icon} size={1} color="rgba(0,0,0,0.60)" />
    </div>

    {/* Text */}
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 4,
      textAlign: 'center',
    }}>
      <span style={{
        fontSize: 13,
        fontWeight: 600,
        color: 'rgba(0,0,0,0.87)',
        lineHeight: '20px',
      }}>
        {title}
      </span>
      {body && (
        <span style={{
          fontSize: 12,
          fontWeight: 400,
          color: 'rgba(0,0,0,0.60)',
          lineHeight: '18px',
          maxWidth: 260,
        }}>
          {body}
        </span>
      )}
    </div>

    {/* Action */}
    {action && (
      <Button emphasis="high" size="m" onClick={action.onClick}>
        {action.label}
      </Button>
    )}
  </div>
);

export default EmptyState;
